// src/main.jsx — entry point do Vite.
//
// Boot order:
//   1. ds-tokens.css (estático top — tokens DS pra todas as rotas).
//   2. bootstrap.js: resolve modo Supabase vs mock, cria window.supa.
//   3. strings.js: window.STR (PT/EN i18n consumido por foundations/toast.jsx
//      e foundations/process.jsx).
//   4. telemetry + sessionTrace + keyboardGhost fix + feedScrollFix.
//   5. mount <RouteSwitch/> com MockApp (default) ou DSPreview (?ds=preview).
//
// Cutover legacy 2026-05-16: app.jsx + sections/* (exceto DSPreview) + hooks/*
// + engine/checklist/consistency/mocks foram deletados. MockApp é a app real
// hoje (Supabase + glass + multi-account). ?legacy=1 hoje cai no default.

import './foundations/ds-tokens.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

// Mantém window.React/ReactDOM pra eventuais consumers externos (ex: dev
// scripts em testes Playwright). Pode sair em futura limpeza se nada usar.
window.React = React;
window.ReactDOM = ReactDOM;

await import('./bootstrap.js');
await import('./strings.js');

const { bootstrapTelemetry } = await import('./foundations/telemetry.js');
bootstrapTelemetry();

const { bootstrapSessionTrace } = await import('./foundations/sessionTrace.js');
bootstrapSessionTrace();

const { installKeyboardGhostFix } = await import('./foundations/keyboardGhost.js');
installKeyboardGhostFix();

const { installFeedScrollFix } = await import('./foundations/feedScrollFix.js');
installFeedScrollFix();

const { DSPreview } = await import('./sections/DSPreview.jsx');
const { MockApp } = await import('./mockpage/MockApp.jsx');
const { AdminApp } = await import('./mockpage/admin/AdminApp.jsx');
const { RouteSwitch } = await import('./foundations/RouteSwitch.jsx');
const { ErrorBoundary } = await import('./foundations/ErrorBoundary.jsx');

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <RouteSwitch>
      {(route) => {
        if (route === 'ds-preview') return <DSPreview/>;
        if (route === 'admin') return <AdminApp/>;
        return <MockApp/>;
      }}
    </RouteSwitch>
  </ErrorBoundary>
);
